const modulePrefix = 'changelog';

export default {
    FETCH_CHANGELOG: `${modulePrefix}/FETCH_CHANGELOG`,
    FETCH_CHANGELOG_SUCCESS: `${modulePrefix}/FETCH_CHANGELOG_SUCCESS`,
    FETCH_CHANGELOG_FAILURE: `${modulePrefix}/FETCH_CHANGELOG_FAILURE`,
};
